import React from "react";
import PropTypes from "prop-types";
import MailChimpForm from "../MailChimpForm";
import SameCategory from "../SameCategory";

import Author from "../Author";

const Article = props => {
  const { children, theme, authornote, posts } = props;

  return (
    <React.Fragment>
      <div className="container">
        <article className="article">{children}</article>
        <div className="rightPanel">
          <div>
            <MailChimpForm theme={theme} />
          </div>
          <div>
            <Author follows theme={theme} note={authornote} />
          </div>

          {!!(posts && posts.length) && (
            <div>
              <SameCategory theme={theme} posts={posts} />
            </div>
          )}

          <div className="sticky">
            <MailChimpForm theme={theme} />
          </div>
        </div>
      </div>
      {/* --- STYLES --- */}
      <style jsx>{`
        .container {
          padding: ${theme.space.inset.default};
          margin: 0 auto;

          display: flex;
        }

        .article {
          flex: 1;
        }

        .rightPanel {
          padding-left: 50px;
        }
        .rightPanel div {
          width: 350px;
          padding: 20px;
          margin-bottom: 2rem;

          background: #fbfcfd;
          border: 1px solid #f2f2f2;
        }

        @to-width tablet {
          .container {
            display: block;
          }
          .rightPanel {
            width: 100%;
          }
        }

        @from-width tablet {
          .container {
            padding: ${`calc(${theme.space.default}) calc(${theme.space.default} * 2)`};
            max-width: ${theme.text.maxWidth.tablet};
          }

          .sticky {
            position: sticky;
            top: 30px;
          }
        }
        @from-width desktop {
          .container {
            padding: ${`calc(${theme.space.default} * 2 + 90px) 0 calc(${theme.space.default} * 2)`};
            max-width: ${theme.text.maxWidth.desktop};
          }

          .sticky {
            top: 100px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Article.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  authornote: PropTypes.string,
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      // TODO: Add Shape here !
    })
  )
};

export default Article;
